function CopyRight() {

    return(
        <footer>
            <p className='copyright'>🎉 Junte-se à nossa família de clientes! Escolha a unidade mais próxima e melhore o seu negócio com os melhores produtos a preços irresistíveis. Estamos prontos para ajudá-lo a alcançar o sucesso que você deseja! 🚀</p>
        </footer>
    )
}

export default CopyRight